'use client';

import HofIcon from './hof';

/**
 * WEA-157 — Hall Of Fame star icon.
 *
 * Même étoile que `hof` (géométrie épaisse, nette aux petites tailles). Single SVG so it scales as
 * one glyph ; the star inherits `currentColor`.
 * `plus` (opt-in) ajoute le badge « + » rouge en haut à droite pour distinguer HOF+ (espaces à la
 * remise legend, ex. −50%) d'un simple HOF ; par défaut l'icône est l'étoile seule.
 */

// Étoile `hof` (grille 32×31) ramenée à 76×73.6 pour occuper la même place que l'ancien tracé.
const STAR_SCALE = 76 / 32;

export default function HofPlusIcon({
  className = 'flex-shrink-0 size-4',
  plus = false,
  badgeFill = '#F75570',
}) {
  if (!plus) return <HofIcon className={className} />;
  return (
    <svg className={className} viewBox="0 0 96 92" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g transform={`translate(0 19) scale(${STAR_SCALE})`}>
        <path fill="currentColor" d="M31.81 11.61H19.66L15.88 0L12.14 11.61H0L9.79 18.79L6.05 30.4L15.88 23.22L25.72 30.41L22 18.79L31.81 11.61ZM12.23 18L6.23 13.66H13.59L15.84 6.66L18.1 13.66H25.48L19.57 18L21.83 25L15.88 20.67L10 25L12.23 18Z" />
        <path fill="currentColor" d="M18.1901 16.9999C18.1901 16.5431 18.0546 16.0965 17.8008 15.7166C17.5469 15.3367 17.1862 15.0406 16.7641 14.8658C16.342 14.6909 15.8775 14.6452 15.4294 14.7343C14.9813 14.8235 14.5697 15.0435 14.2467 15.3665C13.9236 15.6896 13.7036 16.1012 13.6145 16.5493C13.5253 16.9974 13.5711 17.4618 13.7459 17.8839C13.9207 18.306 14.2168 18.6668 14.5967 18.9206C14.9766 19.1745 15.4232 19.3099 15.8801 19.3099C16.4927 19.3099 17.0803 19.0666 17.5135 18.6334C17.9467 18.2002 18.1901 17.6126 18.1901 16.9999Z" />
      </g>
      <circle cx="77" cy="19" r="19" fill={badgeFill} />
      <g transform="translate(70 12)">
        <path
          d="M6 6H1.007a1 1 0 100 2H6v4.993a1 1 0 102 0V8h4.993a1 1 0 100-2H8V1.007a1 1 0 10-2 0V6z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
